export default {
  'backupStoreManagement.title': 'Backup Store List',
};
